import React from 'react';
import { Box, TextButton } from '@zillow/constellation';
import { yieldCallback } from '@zillow/yield-callback';
import { sendEvent } from './B2BMainNav.utils.js';
import { usePageProps } from '../PagePropsProvider/PagePropsProvider.js';
import { getCmsInfoForPage } from '../../utils/clickstream/getCmsInfoForPage.js';
import MenuList from './MenuList.js';

/**
 * Renders a dropdown menu item with the provided item and style.
 *
 * @param {Object} item - The item object containing label and url.
 * @param {Object} sx - The style object for custom styling.
 * @return {JSX.Element} The rendered dropdown menu item.
 */
var DropdownMenuItem = function DropdownMenuItem(_ref) {
  var item = _ref.item,
    sx = _ref.sx;
  var pageProps = usePageProps();
  var cmsInfo = getCmsInfoForPage(pageProps);
  var handleItemClick = function handleItemClick(item) {
    sendEvent('cms_anchor', item.label, item.url, cmsInfo);
    if (item.url) {
      window.open(item.url, '_self');
    }
  };
  return /*#__PURE__*/React.createElement(Box, {
    as: "li",
    sx: Object.assign({
      fontFamily: '$fonts.sansSerif',
      lineHeight: '$lineHeights.body'
    }, sx)
  }, /*#__PURE__*/React.createElement(TextButton, {
    as: "a",
    fontType: "bodySmall",
    href: item.url,
    onClick: yieldCallback(function () {
      handleItemClick(item);
    })
  }, item.label));
};

/**
 * Function to check if the current URL matches the item's URL in the submenu.
 *
 * @param {Object} item - The submenu item to check against the current URL
 * @return {boolean} Returns true if the item's URL matches the current URL, false otherwise
 */
var Dropdown = function Dropdown(_ref2) {
  var submenus = _ref2.submenus,
    dropdown = _ref2.dropdown;
  return /*#__PURE__*/React.createElement(MenuList, {
    sx: {
      display: dropdown ? 'block' : 'none',
      fontSize: '$fontSizes.body',
      fontWeight: '$fontWeights.body',
      paddingInlineStart: '0',
      '@media $xl': {
        backgroundColor: '$colors.backgroundWhite',
        borderRadius: '$radii.md',
        boxShadow: '$shadows.shadow200',
        minWidth: 'calc($spacing.md * 10)',
        overflow: 'hidden',
        position: 'absolute',
        top: '100%'
      },
      '@media $lg_lte': {
        backgroundColor: '$colors.backgroundLight',
        borderTop: 'solid 1px $colors.borderLight',
        padding: '$spacing.xs 0',
        position: 'relative',
        width: '100%'
      }
    }
  }, submenus.map(function (submenu, index) {
    return /*#__PURE__*/React.createElement(DropdownMenuItem, {
      key: index,
      item: submenu,
      sx: {
        padding: '$spacing.xs $spacing.sm',
        ':hover, :focus': {
          color: '$colors.textDark',
          backgroundColor: '$colors.backgroundBlue'
        }
      }
    });
  }));
};
var Dropdown$1 = Dropdown;

export { Dropdown$1 as default };
